<script>
import UListViewItem from 'cloud-ui.vusion/src/components/u-list-view.vue/item.vue';

export default {
    name: 'van-grid-view-item',
    parentName: 'van-grid-view',
    groupName: 'van-grid-view-group',
    extends: UListViewItem,
}
</script>

<style module>
/* @import 'cloud-ui.vusion/src/components/u-list-view.vue/item.css'; */

.root:hover {
    background: none;;
}
</style>
